import { Base } from '@studiometa/js-toolkit';

/**
* StickyBar

*/
export default class KachingBlock extends Base {
    static config = {
        name: 'KachingBlock',
    };

    mounted() {

      this.changePriceLabel();

      // Event when different variants are selected in the bundle deal
      // Event detail contains selected deal variants quantity + variant ID's + Formatted price
      // https://support.kachingappz.com/en/articles/8609400-event-listeners-for-kaching-quantity-bundles-widget
      this.$el.addEventListener('variants-changed', (event) => {

        this.changePriceLabel();

        // Update sale price
        const salePrice = document.querySelectorAll('sale-price');
        salePrice.forEach(price => {
          price.textContent = event.detail.formattedPrice;
        });

        // Update sticky add to cart button content price
        const stickyButton = document.querySelector('.product-sticky-bar__add-to-cart');
        if (!stickyButton) return

        stickyButton.textContent = `Ajouter · ${event.detail.formattedPrice}`;
        stickyButton.classList.remove('tw-pointer-events-none');
        stickyButton.classList.add('tw-pointer-events-auto');

      });


    }

    changePriceLabel() {
      const bars = document.querySelectorAll('.kaching-bundles__bar');
      bars.forEach(bar => {
          this.injectPriceLabel(bar);
          bar.addEventListener('click', () => {
              const bars = document.querySelectorAll('.kaching-bundles__bar');
              const firstBar = bars[0];
              const secondBar = bars[1];
              if (bar === firstBar && secondBar) {
                  const secondBarTitle = secondBar.querySelector('.kaching-bundles__bar-title').textContent;
                  const secondBarPrice = secondBar.querySelector('.kaching-bundles__bar-price').textContent;
                  const priceLabel = document.querySelector('.price__save_label');
                  priceLabel.textContent = 'Economisez : ' + `${secondBarTitle} pour ${secondBarPrice}`;
                  return;
              }
              this.injectPriceLabel(bar);
          });
      });
    }

    injectPriceLabel(bar) {
        const nbr = bar.querySelector('.kaching-bundles__bar-title').textContent;
        const price = bar.querySelector('.kaching-bundles__bar-price').textContent;
        const priceLabel = document.querySelector('.price__save_label');
        priceLabel.textContent = 'Economisez : ' + `${nbr} pour ${price}`;
        priceLabel.classList.remove('tw-opacity-0', 'tw-translate-x-8');
    }

}
